import { useMutation, useQuery } from 'react-query'
import { useEffect, useRef, useState } from 'react'
import { AxiosError } from 'axios'
import { TenantForSidebarDto } from '../../MyTenant/tenantsModel'
import { getRebuildableJobs, rebuildSnapshots, RebuildSnapshotsRequest, RebuildSnapshotsResult } from './rebuildSnapshotsApi'
import { AllTenantsProgress, rebuildEachTenant } from './rebuildSnapshotsModel'

export const useRebuildableJobsQuery = (tenantId: number | undefined, enabled: boolean) => {
  return useQuery(['admin', 'job-snapshots', 'jobs', tenantId ?? 0], {
    queryFn: () => getRebuildableJobs(tenantId as number),
    enabled: enabled && tenantId !== undefined,
    refetchOnWindowFocus: false,
  })
}

export const useRebuildSnapshotsMutation = () => {
  return useMutation<RebuildSnapshotsResult, AxiosError, RebuildSnapshotsRequest>({
    mutationFn: (request: RebuildSnapshotsRequest) => rebuildSnapshots(request),
  })
}

export const useRebuildAllTenants = () => {
  const [progress, setProgress] = useState<AllTenantsProgress | null>(null)
  const isMounted = useRef(true)

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  const mutation = useMutation<AllTenantsProgress, AxiosError, TenantForSidebarDto[]>({
    mutationFn: (tenants: TenantForSidebarDto[]) =>
      rebuildEachTenant(tenants, rebuildSnapshots, setProgress, () => isMounted.current),
  })

  const reset = () => {
    mutation.reset()
    setProgress(null)
  }

  return { progress, isRunning: mutation.isLoading, start: mutation.mutate, reset }
}
